<div
  #dropdownMenu
  [class]="suggestionsClass"
  [ngClass]="{ 'show-suggestions': dropdownShown, 'hide-suggestions': !dropdownShown }"
>
  @for (address of addressGuesses; track address) {
    <div
      data-cy="drpSearchByLocationAddressAutofill"
      class="autocomplete-suggestion"
      [class.active]="activeChoice === address"
      (click)="emitSelectedAddress(address)"
      clickOutside
      (clickOutside)="hideDropdownOnClick()"
    >
      {{ address.description }}
    </div>
  }
</div>
